import React, { useState, useEffect } from "react";
import Multiselect from "react-widgets/Multiselect";

export const MultiselectFieldMrErf = ({
  index,
  id,
  name,
  code,
  label,
  placeholder,
  error,
  data,
  setValue,
  getvalue = () => {},
  disabled,
  onChangeValue = () => {},
  extraLabel = "",
  required,
}) => {

  const [selectedData, setSelectedData] = useState(setValue || []);

  useEffect(() => {
    let obj = {
      selected: selectedData,
      textField: name,
      textCode: code,
      index: index,
    };

    getvalue(obj);
    onChangeValue(index, name, selectedData);
     // eslint-disable-next-line
  }, [selectedData]);

  // Format the display text on the fly
  const getDisplayText = (item) => {
    if (item.label) return item.label;
    if (item.materialCode && item.materialDescription) {
      return `${item.materialCode} - ${item.materialDescription}`;
    }
    return item.materialDescription || item.materialCode || "";
  };

  return (
    <>
      <label className="block text-sm font-medium leading-6 text-gray-900 infoIconAccordion">
        {label} {required && <span style={{ color: "red" }}> *</span>}
      </label>

      <Multiselect
        id={id}
        name={name}
        className="dropdownHive w-full rounded-md"
        data={data}
        dataKey="materialCode"
        textField={getDisplayText}
        value={selectedData}
        onChange={(value) => setSelectedData(value)}
        filter="contains"
        placeholder={placeholder}
        disabled={disabled}
      />

      {error?.message && (
        <span className="text-red-500 text-xs">{error.message}</span>
      )}
    </>
  );
};